import { isOrangePiBoard } from '@/utils/orangePi';
/**
 * Which main vendos can host VLAN sub-vendos.
 *
 * MikroTik always. OpenWRT only for the boards the server's OPENWRT_BOARDS
 * catalog can wire: the OrangePi and the x86 mini PC (Ray, 2026-09-20). AX3000
 * and AX1800 come later, in their own work; Ruijie and Comfast are not planned.
 *
 * ONE definition, used by everything that gates on it - the Networks page
 * picker AND the "+ Add Sub-Vendo" button. They were separate once: the picker
 * was taught about the OrangePi and the button was not, so on the first bench
 * (2026-09-21) the VLANs went live and the button still said "Sub-vendos aren't
 * supported on Lite routers yet".
 */
export function canHostVlans(platform: string | undefined, hwBoard: string | undefined): boolean {
   if (platform !== 'openwrt') return true;
   const b = (hwBoard ?? '').toLowerCase();
   return isOrangePiBoard(b) || b.startsWith('x86-64,');
}
